import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { getUserData } from "../utils/localStorage";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { getLead, getLeadSource, getLeadType, getUserLead } from "../services/leads";
import { errorMessage } from "../utils/alertMessage";
import { getBank, getBanker, getBranch, getLoanFile, getLoanFileStatus, getProduct, getStateWiseCities, getUser } from "../services/userMasterUser";
import { MultiSelect } from "primereact/multiselect";

const DashboardAdmin = () => {
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { userProfileData } = getUserData();

  const toggleFilter = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 3); // subtract 7 days to current date

  const [startDateValue, setStartDateValue] = useState(new Date(initialStartDate));
  const [endDateValue, setEndDateValue] = useState(new Date());

  const [stateCitiesList, setStateCitiesList] = useState([])
  const [stateCityList, setStateCityList] = useState({});

  const recordTypeSelection = [
    { label: "CreatedOn", value: "CreatedOn" },
    { label: "LeadOn", value: "LeadOn" },
    { label: "FollowUpOn", value: "FollowUpOn" },
    { label: "ClosedOn", value: "ClosedOn" },
    { label: "RequestOn", value: "RequestOn" },
    { label: "SanctionOn", value: "SanctionOn" },
    { label: "DisbursedOn", value: "DisbursedOn" },
  ]

  const [recordTypeValue, setRecordTypeValue] = useState("CreatedOn")
  const [leadTypeList, setLeadTypeList] = useState([])
  const [typeOfLead, setTypeOfLead] = useState('')

  const [leadData, setLeadData] = useState([])

  const [branchDataList, setBranchDataList] = useState([])
  const [productDataList, setProductDataList] = useState([])
  const [branchDataValue, setBranchDataValue] = useState("")
  const [productDataValue, setProductDataValue] = useState("")
  const [userDataFilter, setUserDataFilter] = useState("");

  const [stateValue, setStateValue] = useState('')
  const [cityValue, setCityValue] = useState('')

  const [userDataIds, setUserDataIds] = useState([]);

  const citiesList = stateCityList[stateValue] || [];

  const [loanFileDataList, setLoanFileDataList] = useState([])

  const [leadSourceValue, setLeadSourceValue] = useState("")
  const [leadSourceList, setLeadSourceList] = useState([])
  const [bankListData, setBankListData] = useState([])
  const [bankListAllData, setBankListAllData] = useState([])
  const [bankDataValue, setBankDataValue] = useState([])
  const [fileStatusData, setFileStatusData] = useState([]);
  const [fileStatusDataValue, setFileStatusDataValue] = useState([]);
  const [bankerAllList, setBankerAllList] = useState([])
  const [bankerList, setBankerList] = useState([])
  const [bankerDataValue, setBankerDataValue] = useState([])
  const [bankCategoryValue, setBankCategoryValue] = useState("")


  const bankCategoryList = [
    { label: "Nationalised Bank", value: "Nationalised bank" },
    { label: "Private Bank", value: "Private Bank" },
    { label: "Financial Institution", value: "Financial Institution" },
    { label: "Small Bank", value: "Small Bank" },
    { label: "Alternative Investment Fund", value: "Alternative Investment Fund" },
  ]

  const LoanFileApi = {
    searchBy: "",
    searchText: "",
    limit: 100000,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: []
  };

  const fetchLoanFileData = (data) => {

    getLoanFile(data)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          setLoanFileDataList(newData);

        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })

  };

  const fetchBankerData = (bankerData) => {
    getBanker(bankerData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs

          const activeBanker = newData.filter((item) => item.status === "ACTIVE");
          const bankerDataList = activeBanker.map((item) => ({
            label: item?.city + "-" + item?.bank?.name + "-" + item?.bank?.category + "-" + item.nameOfBanker + "-" + item?.mobile + "-Limit: " + "Min-" + item?.minimumLoanAmount + ", Max-" + item?.maximumLoanAmount,
            value: item.id,
          }));

          setBankerAllList(bankerDataList);
          setBankerList(bankerDataList);

        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
  }

  useEffect(() => {


    fetchLoanFileData(LoanFileApi)

    getLeadType()
      .then((response) => {
        if (!response.data.error) {
          const leadStatus = response.data.map((item) => ({
            label: item,
            value: item,
          }));
          setLeadTypeList(leadStatus);
          fetchData({
            ...typeData,
            recordType: "CreatedOn",
            startDate: startDateValue,
            endDate: endDateValue,
            leadTypeIn: response.data
          });
        }
      })
      .catch(() => errorMessage());


    const stateCitiesData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      cityIn: [],
      stateIn: []
    }

    getStateWiseCities(stateCitiesData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          // const stateList = Object.keys(Res).map((key) => ({
          //   key
          // }));

          const stateListArray = Object.keys(Res);

          const stateList = stateListArray.map((item) => ({
            label: item,
            value: item,
          }));

          setStateCitiesList(stateList)

          setStateCityList(Res)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));


    const typeBranchData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: []
    };

    getBranch(typeBranchData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const branchData = newData.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          setBranchDataList(branchData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })


    const typeProductData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: []
    };

    getProduct(typeProductData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const productData = newData.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          setProductDataList(productData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })

    const userData = {
      searchBy: "",
      searchText: "",
      limit: 1000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      userTypeIdIn: [],
      roleIn: ["ROLE_TELECALLER", "ROLE_OPERATION"],
      statusIn: []

    };

    getUser(userData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const newDataId = newData.map(item => item.id);
          const newDataIds = newData.map(item => ({
            label: item.userName + " - " + item?.userTypeInfo, value: item.id
          }));

          setUserDataIds(newDataIds)
        }
      })
      .catch(() => {
        errorMessage();
      })

    const bankerData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: [],
      // bankIdIn: []
    };

    fetchBankerData(bankerData)

    getLeadSource()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const leadSource = Res.map((item) => ({
            label: item,
            value: item,
          }));


          setLeadSourceList(leadSource)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })

    getBank()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          const bankList = Res.map((item) => ({
            label: item.name,
            value: item.id,
            category: item.category
          }));

          setBankListAllData(bankList)
          setBankListData(bankList)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })

    getLoanFileStatus()
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs

          const dataList = newData.map((item) => ({
            label: item,
            value: item,
          }));

          setFileStatusData(dataList);

        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })


  }, [])

  const typeData = {
    searchBy: "",
    searchText: "",
    limit: 100000,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: [],
    sourceIn: [],

    recordType: recordTypeValue,
    startDate: "",
    endDate: "",
    leadTypeIn: [], // leadType ka selection
    userIdIn: []
  };

  const fetchData = (data) => {

    getUserLead(data)
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;

          // 🔥 Extract only the lead object
          // const newData = rawData.map(item => item.lead);


          setLeadData(rawData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
      });
  };

  useEffect(() => {

    let startDate = "";
    let endDate = "";

    if (startDateValue) {
      startDate = new Date(startDateValue);
      endDate = endDateValue ? new Date(endDateValue) : new Date();
    }

    const hasValidFilter =
      recordTypeValue ||
      typeOfLead ||
      startDateValue ||
      endDateValue ||
      stateValue ||
      cityValue ||
      branchDataValue ||
      productDataValue ||
      userDataFilter;

    if (!hasValidFilter) return;

    fetchData({
      ...typeData,
      recordType: recordTypeValue,
      startDate,
      endDate,
      leadTypeIn: [typeOfLead],
      branchIdIn: branchDataValue ? branchDataValue : [],
      productIdIn: productDataValue ? productDataValue : [],
      userIdIn: userDataFilter ? userDataFilter : [],
      addressInfo: { cityIn: cityValue ? cityValue : [], stateIn: stateValue ? [stateValue] : [] }
    });

  }, [recordTypeValue, typeOfLead, startDateValue, endDateValue, branchDataValue, productDataValue, userDataFilter]);

  useEffect(() => {

    let startDate = "";
    let endDate = "";

    if (startDateValue) {
      startDate = new Date(startDateValue);
      endDate = endDateValue ? new Date(endDateValue) : new Date();
    }

    const hasValidFilter =
      stateValue ||
      cityValue ||
      startDateValue ||
      endDateValue ||
      // branchCategoryValue ||
      typeOfLead ||
      userDataFilter ||
      branchDataValue ||
      leadSourceValue ||
      recordTypeValue ||
      bankCategoryValue ||
      bankDataValue ||
      bankerDataValue ||
      fileStatusDataValue ||
      productDataValue;

    if (!hasValidFilter) return;

    const payload = {
      ...typeData,
      statusIn: [],
      // branchCategoryIn: branchCategoryValue ? branchCategoryValue : [],
      addressInfo: { cityIn: cityValue ? cityValue : [], stateIn: stateValue ? [stateValue] : [] },
      leadTypeIn: typeOfLead ? [typeOfLead] : [],
      fileStatusIn: fileStatusDataValue ? fileStatusDataValue : [], // request , sanction , disbursed, diclined
      userIdIn: userDataFilter ? userDataFilter : [],
      branchIdIn: branchDataValue ? branchDataValue : [],
      productIn: productDataValue ? productDataValue : [],
      sourceIn: leadSourceValue ? leadSourceValue : [],
      recordType: recordTypeValue,
      startDate,
      endDate,
      bankCategoryIn: bankCategoryValue ? [bankCategoryValue] : [], // bank category if (bank category is selected then show bank id)
      bankIdIn: bankDataValue ? bankDataValue : [], // bank list // multi if (bank id  is selected then show banker id)
      bankerIdIn: bankerDataValue ? bankerDataValue : [] // banker list
    };

    fetchLoanFileData(payload);

  }, [
    stateValue,
    cityValue,
    startDateValue,
    endDateValue,
    // branchCategoryValue,
    productDataValue,
    fileStatusDataValue,
    typeOfLead,
    userDataFilter,
    branchDataValue,
    leadSourceValue,
    recordTypeValue,
    bankCategoryValue,
    bankDataValue,
    bankerDataValue,
  ]);

  // const leadStatusMap = leadData.reduce((acc, item) => {
  //   const status = item.lead.status;

  //   if (!acc[status]) {
  //     acc[status] = [];
  //   }

  //   acc[status].push(item.lead);

  //   return acc;
  // }, {});

  const leadStatusMap2 = Object.groupBy(leadData, item => item.lead.status);

  const statusTotals = Object.fromEntries(
    Object.entries(leadStatusMap2).map(([status, items]) => [
      status,
      items.reduce((sum, item) => sum + item.lead.amount, 0) // change "amount" to your field
    ])
  );

  const result = Object.entries(leadStatusMap2).map(([status, items]) => ({
    status,
    amount: items.reduce((sum, item) => sum + item.lead.amount, 0),
    count: items.length
  }));

  return (
    <main id="main" className="main">
      <section className="section dashboard">
        <div className="row">
          {/* Left side columns */}
          <div className="col-lg-12">
            <div className="row">
              {/* Sales Card */}
              <div className=" col-md-12">
                <div className="card info-card sales-card">
                  <div className="card-body">
                    <div
                      style={{
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h5 className="card-title">
                        Admin Dashboard <span>| Financeseva</span>
                      </h5>
                      <i
                        className="pi pi-filter-fill"
                        onClick={toggleFilter}
                        style={{ color: "#1e439b" }}
                      ></i>
                    </div>
                    {isFilterVisible && <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginTop: 5,
                        marginBottom: 5,
                      }}
                    >
                      <div className="row">

                        <div className="col-md mb-2">
                          <Dropdown
                            style={{ width: "100%" }}
                            options={leadTypeList}
                            value={typeOfLead}
                            placeholder="Select Lead Type"
                            onChange={(e) => {
                              setTypeOfLead(e.value);
                            }}
                          />
                        </div>

                        <div className="col-md mb-2">
                          <Dropdown
                            style={{ width: "100%" }}
                            options={recordTypeSelection}
                            value={recordTypeValue}
                            placeholder="Select Record Type"
                            onChange={(e) => {
                              setRecordTypeValue(e.value);
                            }}
                          />
                        </div>
                        <div className="col-md mb-2">
                          <Calendar
                            value={startDateValue}
                            onChange={(e) => {
                              const start = e.value;
                              setStartDateValue(start);

                              if (!endDateValue) {
                                setEndDateValue(new Date()); // default today
                              }
                            }}
                            dateFormat="dd/mm/yy"
                            placeholder="Start Date"
                            maxDate={endDateValue ? endDateValue : new Date()}
                            showIcon
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div className="col-md mb-2">
                          <Calendar
                            value={endDateValue}
                            onChange={(e) => setEndDateValue(e.value)}
                            dateFormat="dd/mm/yy"
                            placeholder="End Date"
                            minDate={startDateValue}
                            showIcon
                            style={{ width: "100%" }} />
                        </div>
                        <div className="col-md mb-2">
                          <Dropdown
                            style={{ width: "100%" }}
                            value={stateValue}
                            onChange={(e) => {
                              setStateValue(e.value);
                              setCityValue([])
                            }
                            }
                            options={stateCitiesList}
                            optionLabel="label"
                            placeholder="Select a State"
                            filter
                            filterDelay={400}
                          />
                        </div>

                        <div className="col-md mb-2">
                          <MultiSelect
                            style={{ width: "100%" }}
                            value={cityValue}
                            onChange={(e) => setCityValue(e.value)}
                            options={citiesList}
                            placeholder="Select City"
                          />
                        </div>

                        <div className="col-md mb-2">
                          <MultiSelect
                            style={{ width: "100%" }}
                            value={branchDataValue}
                            onChange={(e) => setBranchDataValue(e.value)}
                            options={branchDataList}
                            optionLabel="label"
                            placeholder="Select Branch"
                          />
                        </div>
                        <div className="col-md mb-2">
                          <MultiSelect
                            style={{ width: "100%" }}
                            value={productDataValue}
                            onChange={(e) => setProductDataValue(e.value)}
                            options={productDataList}
                            optionLabel="label"
                            placeholder="Select Product"
                          />
                        </div>
                        <div className="col-md mb-2">
                          <MultiSelect
                            style={{ width: "100%" }}
                            value={userDataFilter}
                            onChange={(e) => setUserDataFilter(e.value)}
                            options={userDataIds}
                            optionLabel="label"
                            placeholder="Select User"
                          />
                        </div>
                      </div>


                    </div>}

                    <div className="row">
                      <div className=" col-md-4">
                        <div className="card">
                          <Card title="" style={{ color: "#ff5501" }}>
                            <h3 className="m-0">
                              <i className={"bi bi-box"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                Lead Box
                              </span>
                              <span style={{ color: "#ff5501", marginLeft: 10 }}>
                                | {leadData.length} Leads
                              </span>
                            </h3>
                          </Card>
                        </div>
                      </div>
                    </div>
                    {isFilterVisible && <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginTop: 5,
                        marginBottom: 5,
                      }}
                    >
                      <div className="row">

                        <div className="col-md mb-2">
                          <MultiSelect
                            style={{ width: "100%" }}
                            value={leadSourceValue}
                            onChange={(e) => setLeadSourceValue(e.value)}
                            options={leadSourceList}
                            optionLabel="label"
                            placeholder="Select Lead Source"
                          />
                        </div>
                        <div className="col-md mb-2">
                          <Dropdown
                            style={{ width: "100%" }}
                            options={bankCategoryList}
                            value={bankCategoryValue}
                            optionLabel="label"
                            placeholder="Select Category"
                            onChange={(e) => {
                              setBankCategoryValue(e.value)
                              const bankFilter = bankListAllData.filter((item) => item.category == e.value);
                              setBankListData(bankFilter)
                              setBankDataValue([])
                            }
                            }
                          />
                        </div>

                        <div className="col-md mb-2">
                          <MultiSelect
                            style={{ width: "100%" }}
                            options={bankListData}
                            value={bankDataValue}
                            onChange={(e) => {
                              setBankDataValue(e.value)
                              const bankerData = {
                                searchBy: "",
                                searchText: "",
                                limit: 100000,
                                offset: 0,
                                sortBy: "",
                                sortOrder: "desc",
                                statusIn: [],
                                bankIdIn: e.value
                              };

                              fetchBankerData(bankerData)
                              setBankerDataValue([])
                            }
                            }
                            optionLabel="label"
                            placeholder="Select Bank"
                          />
                        </div>

                        <div className="col-md mb-2">
                          <MultiSelect
                            style={{ width: "100%" }}
                            options={bankerList}
                            value={bankerDataValue}
                            onChange={(e) =>
                              setBankerDataValue(e.value)}
                            optionLabel="label"
                            placeholder="Select Banker"
                          />
                        </div>

                        <div className="col-md mb-2">
                          <Dropdown
                            style={{ width: "100%" }}
                            options={fileStatusData}
                            value={fileStatusDataValue}
                            placeholder="Select File Status"
                            onChange={(e) => {
                              setFileStatusDataValue(e.value);
                            }}
                          />
                        </div>
                      </div>


                    </div>}

                    <div className="row">
                      <div className=" col-md-4">
                        <div className="card">
                          <Card title="" style={{ color: "#ff5501" }}>
                            <h3 className="m-0">
                              <i className={"bi bi-box"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                Loan File
                              </span>
                              <span style={{ color: "#ff5501", marginLeft: 10 }}>
                                | {loanFileDataList.length}
                              </span>
                            </h3>
                          </Card>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      {result.map((resultItem) => (
                        <div className=" col-md-4">
                          <div className="card">
                            <Card title="" style={{ color: "#ff5501" }}>
                              <h3 className="m-0">
                                <i className={"bi bi-box"} />
                                <span style={{ color: "#1e439b", marginLeft: 10, textTransform: "capitalize" }}>
                                  {resultItem.status} - {resultItem.count}
                                </span>
                                <span style={{ color: "#ff5501", marginLeft: 10 }}>
                                 | Amount - {Math.round(resultItem.amount)}
                                </span>
                              </h3>
                            </Card>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/*<div className="row">
                      {Object.keys(leadStatusMap2).map((leadStatusData) => (
                      <div className=" col-md-4">
                        <div className="card">
                          <Card title="" style={{ color: "#ff5501" }}>
                            <h3 className="m-0">
                              <i className={"bi bi-box"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                  {leadStatusData} - {leadStatusMap2[leadStatusData].length}
                              </span>
                            </h3>
                          </Card>
                        </div>
                      </div>
                      ))}
                    </div>*/}

                    <div
                      style={{
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h5 className="card-title">
                        Directory
                      </h5>
                    </div>
                    <div className="row">
                      <div className=" col-md-4">
                        <div className="card">
                          <Card title="" style={{ color: "#ff5501" }}>
                            <h3 className="m-0">
                              <i className={"bi bi-box"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                Bank
                              </span>
                            </h3>
                          </Card>
                        </div>
                      </div>
                      <div className=" col-md-4">
                        <div className="card">
                          <Card title="" style={{ color: "#ff5501" }}>
                            <h3 className="m-0">
                              <i className={"bi bi-box"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                Banker
                              </span>
                            </h3>
                          </Card>
                        </div>
                      </div>
                      <div className=" col-md-4">
                        <div className="card">
                          <Card title="" style={{ color: "#ff5501" }}>
                            <h3 className="m-0">
                              <i className={"bi bi-box"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                Company
                              </span>
                            </h3>
                          </Card>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className=" col-md-4">
                        <div className="card">
                          <Card title="" style={{ color: "#ff5501" }}>
                            <h3 className="m-0">
                              <i className={"bi bi-box"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                CA User
                              </span>
                            </h3>
                          </Card>
                        </div>
                      </div>
                      <div className=" col-md-4">
                        <div className="card">
                          <Card title="" style={{ color: "#ff5501" }}>
                            <h3 className="m-0">
                              <i className={"bi bi-box"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                Product
                              </span>
                            </h3>
                          </Card>
                        </div>
                      </div>
                      <div className=" col-md-4">
                        <div className="card">
                          <Card title="" style={{ color: "#ff5501" }}>
                            <h3 className="m-0">
                              <i className={"bi bi-box"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                Business Partner
                              </span>
                            </h3>
                          </Card>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default DashboardAdmin;
